var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showItems.length > 0
      ? _c(
          "div",
          { staticClass: "accordion", attrs: { id: "accordionExample" } },
          [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-header", attrs: { id: "headingOne" } },
                [
                  _c("h2", { staticClass: "mb-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "no-border text-left",
                        attrs: {
                          type: "button",
                          "data-toggle": "collapse",
                          "data-target": "#collapseOne",
                          "aria-expanded": "true",
                          "aria-controls": "collapseOne"
                        }
                      },
                      [
                        _vm._v(
                          "\n                       " +
                            _vm._s(
                              _vm.$translate(
                                "Klettershop5::Template.zusammenkaufen"
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapse show",
                  attrs: {
                    id: "collapseOne",
                    "aria-labelledby": "headingOne",
                    "data-parent": "#accordionExample"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("div", { staticClass: "combisell" }, [
                        _c(
                          "ul",
                          { staticClass: "list-unstyled list-inline" },
                          [
                            _vm.loading === true
                              ? [_vm._m(0)]
                              : [
                                  _vm.showItems
                                    ? [
                                        _vm._l(_vm.showItems, function(
                                          item,
                                          index
                                        ) {
                                          return [
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "list-inline-item px-2"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/" +
                                                        item.data.texts
                                                          .urlPath +
                                                        "/a-" +
                                                        item.data.item.id +
                                                        "/"
                                                    }
                                                  },
                                                  [
                                                    item.data.images.variation
                                                      .length > 0
                                                      ? [
                                                          _c("img", {
                                                            staticClass:
                                                              "img-fluid",
                                                            attrs: {
                                                              src:
                                                                item.data.images
                                                                  .variation[0]
                                                                  .urlMiddle
                                                            }
                                                          })
                                                        ]
                                                      : [
                                                          _c("img", {
                                                            staticClass:
                                                              "img-fluid",
                                                            attrs: {
                                                              src:
                                                                item.data.images
                                                                  .all[0]
                                                                  .urlMiddle
                                                            }
                                                          })
                                                        ]
                                                  ],
                                                  2
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            index < _vm.showItems.length - 1
                                              ? [
                                                  _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "list-inline-item  px-2"
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-plus"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index + 1 == _vm.showItems.length
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "text-center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.$translate(
                                                              "Klettershop5::Template.priceall"
                                                            )
                                                          ) +
                                                          "  "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              _vm.pricesAll
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-default ml-lg-3 mt-3",
                                                          attrs: {
                                                            disabled:
                                                              _vm.waiting
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.buyItems()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(
                                                                _vm.$translate(
                                                                  "Klettershop5::Template.buyall"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                          _vm.waiting
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fa fa-circle-o-notch fa-spin fa-fw"
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        })
                                      ]
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.showItems
                        ? [
                            _c(
                              "ul",
                              { staticClass: "list-unstyled mt-3" },
                              [
                                _vm._l(_vm.showItems, function(item, index) {
                                  return [
                                    _c("li", [
                                      _c("input", {
                                        attrs: { type: "checkbox" },
                                        domProps: { checked: item.active },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleActive(item)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          class: {
                                            "text-stroke text-muted":
                                              item.active == false
                                          },
                                          attrs: {
                                            href:
                                              "/" +
                                              item.data.texts.urlPath +
                                              "/a-" +
                                              item.data.item.id +
                                              "/",
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.data.texts.name1))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold ml-3"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  item.data.prices.default.price
                                                    .value
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-block text-center w-100" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" }
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }